import $ from "jquery";
import axios from "axios";
import {addShareBtn} from "../materials/common/eternalScrollOnReadyHandlers";
import {handlerVkShareBtn} from "./vk-share-btn-handler";

export const insertSharingButtons = () => {
    $('.share-btn-container, .share-btn-container-need-load').each(function () {
        getLinks($(this));
    });
};

export const getLinks = (element) => {
    const elementData = element.data();

    axios.get(elementData['url'], {
        params: {
            entityId: elementData['entityId'],
            entityType: elementData['entityType'],
            additionalId: elementData['additionalId'],
            additionalParams: elementData['additionalParams'],
            isWhite: element.is('[data-is-white]')
        }
    })
        .then((response) => {
            element.append(response.data.data);

            addShareBtn(elementData['entityId'], response.data.data);
            handlerVkShareBtn();
        });
};
